import { useValidationMessageTranslationsT } from "src/translation-hooks/validation-message-translations";
import { REGEX } from "./constants";

export const passwordValidationCheckmarks = (password: string, translation: ReturnType<typeof useValidationMessageTranslationsT>) => {
  return [
    { text: translation.atleast8Characters, checked: password.length > 8 },
    { text: translation.includeUpperandLowercaseLetters, checked: REGEX.containUpperCase.test(password) },
    { text: translation.containNumbers, checked: REGEX.containsNumber.test(password) },
    { text: translation.containSpecialCharacters, checked: REGEX.containSpecialCharacter.test(password) }
  ];
};
